import { render, staticRenderFns } from "./ConfirmDialogCpt.vue?vue&type=template&id=55afc8bd&"
import script from "./ConfirmDialogCpt.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDialogCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports